var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useAuth } from './AuthContext';
import { TextField, Button, Typography, Box, CircularProgress, InputAdornment, FormControlLabel, Checkbox, Link } from '@mui/material';
import { Email, Lock, PersonAdd } from '@mui/icons-material';
import { useNotification } from '../context/NotificationContext';
export const EmailSignupForm = ({ onSuccess, onError }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [agreeToTerms, setAgreeToTerms] = useState(true);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { signUpWithEmail } = useAuth();
    const { showNotification } = useNotification();
    // Show error notification when there's an error
    const prevErrorRef = useRef(null);
    useEffect(() => {
        if (error && error !== prevErrorRef.current) {
            prevErrorRef.current = error;
            showNotification({
                message: error,
                severity: 'error'
            });
            // Also call the onError callback if provided
            if (onError) {
                onError(new Error(error));
            }
        }
    }, [error, showNotification, onError]);
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        setError(null);
        if (!email || !password || !confirmPassword) {
            setError('Please fill in all fields');
            return;
        }
        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        if (!agreeToTerms) {
            setError('You must agree to the Terms of Service');
            return;
        }
        try {
            setLoading(true);
            yield signUpWithEmail(email, password);
            if (onSuccess)
                onSuccess();
        }
        catch (err) {
            setError(err.message || 'Failed to sign up');
        }
        finally {
            setLoading(false);
        }
    });
    return (_jsxs(Box, { component: "form", onSubmit: handleSubmit, noValidate: true, children: [_jsx(Typography, { variant: "h6", component: "h2", gutterBottom: true, children: "Sign Up" }), _jsx(TextField, { margin: "normal", required: true, fullWidth: true, id: "email", label: "Email Address", name: "email", autoComplete: "email", autoFocus: true, value: email, onChange: (e) => setEmail(e.target.value), disabled: loading, InputProps: {
                    startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(Email, {}) })),
                } }), _jsx(TextField, { margin: "normal", required: true, fullWidth: true, name: "password", label: "Password", type: "password", id: "password", autoComplete: "new-password", value: password, onChange: (e) => setPassword(e.target.value), disabled: loading, InputProps: {
                    startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(Lock, {}) })),
                } }), _jsx(TextField, { margin: "normal", required: true, fullWidth: true, name: "confirmPassword", label: "Confirm Password", type: "password", id: "confirmPassword", autoComplete: "new-password", value: confirmPassword, onChange: (e) => setConfirmPassword(e.target.value), disabled: loading, InputProps: {
                    startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(Lock, {}) })),
                } }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { value: "agreeToTerms", color: "primary", checked: agreeToTerms, onChange: (e) => setAgreeToTerms(e.target.checked), disabled: loading }), label: _jsxs(Typography, { variant: "body2", children: ["I agree to the ", _jsx(Link, { href: "https://www.rentreadybids.com/terms-of-service", target: "_blank", rel: "noopener", underline: "hover", children: "Terms of Service" })] }), sx: { mt: 2 } }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", sx: { mt: 3, mb: 2 }, disabled: loading, startIcon: loading ? _jsx(CircularProgress, { size: 24 }) : _jsx(PersonAdd, {}), children: loading ? 'Signing up...' : 'Sign Up' })] }));
};
